/**
 * Quick Buy Functionality
 * Handles card clicks to show overlay and accordion behavior for variant selection
 */

if (!window.QuickBuyAccordion) {
  window.QuickBuyAccordion = class QuickBuyAccordion {
    constructor() {
      this.init();
    }

  init() {
    // Wait for DOM to be fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupEventListeners());
    } else {
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    // Handle card clicks to show overlay
    document.addEventListener('click', (e) => {
      const card = e.target.closest('.quick-buy-card');
      
      // If clicked inside an active card's overlay
      if (card && card.classList.contains('quick-buy-active')) {
        // Check if click is on an interactive element
        const isInteractive = e.target.closest('button, a, input, select, textarea, form, .button, .quick-buy-overlay__content');
        
        if (!isInteractive) {
          // Clicked on overlay background, close it
          e.preventDefault();
          this.hideQuickBuy(card);
          return;
        }
        
        // Check if it's the quick-add toggle button
        const button = e.target.closest('.quick-add-toggle');
        if (button) {
          e.preventDefault();
          e.stopPropagation();
          this.handleToggle(button);
          return;
        }
        
        // Let interactive elements work normally
        return;
      }
      
      // If clicked on a card that doesn't have overlay active, show it
      if (card && !card.classList.contains('quick-buy-active')) {
        e.preventDefault();
        this.showQuickBuy(card);
        return;
      }
    });

    // Handle escape key to close overlay
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.hideAllQuickBuy();
      }
    });
  }

  showQuickBuy(card) {
    // Close any other open overlays first
    this.hideAllQuickBuy();
    
    // Show this overlay
    card.classList.add('quick-buy-active');
  }

  hideQuickBuy(card) {
    card.classList.remove('quick-buy-active');
  }

  hideAllQuickBuy() {
    const activeCards = document.querySelectorAll('.quick-buy-card.quick-buy-active');
    activeCards.forEach(card => {
      card.classList.remove('quick-buy-active');
    });
  }

  handleToggle(button) {
    // Toggle active class on button (for chevron rotation)
    button.classList.toggle('active');
    
    // Find the variants container - look in the same actions container
    const actionsContainer = button.closest('.quick-buy-overlay__actions');
    const variantsContainer = actionsContainer ? actionsContainer.querySelector('.quick-buy-variants') : null;
    
    if (variantsContainer) {
      variantsContainer.classList.toggle('active');
    }
  }
  };

  // Initialize when script loads (only once)
  if (!window.quickBuyInstance) {
    window.quickBuyInstance = new window.QuickBuyAccordion();
  }
}